import React from 'react';
import { Icon } from 'design-react-kit/dist/design-react-kit';

/*
 * Customization with image
 *
 * If you have a jpg/png, do like this:
 *
 * <figure className="icon">
 *  <img src={logo} alt="" />
 * </figure>
 *
 * Note the icon class.
 */

const Logo = () => null;
{
  /* <Icon color="" icon="it-pa" padding={false} size="" />; */
}

export default Logo;
